<template>
  <div style="list-style:none" :id="bindId">
    <div href="javascript:;"  class="dropdown-toggle unselectable notification-bell " role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> 
                      </span><i class=" fa fa-bell-o animated" v-bind:class="{'swing': active}" @mouseover="active=true" @mouseleave="active=false"></i><label v-if="unreadNotificationsComp.length>0" class="badge badge-error">{{unreadNotificationsComp.length}}</label> </div>
    
    <ul class="dropdown-menu dropdown-menu-right scrollable-menu">
      <li v-for="(notification, index) in notificationsComp" :key="notification.UserNotificatoionId">
        
        <div v-bind:class="{read: notification.IsRead}" class="custom-class">
          <h5><button style="font-size: xx-large;" type="button" @click="deleteNotification(notification)" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></h5>
          
           <span style="margin-left:3px;" > <img class="img img-circle" style="width:auto;height:30px" :src="notification.ProfilePic" crossOrigin="Anonymous">
                  </span> <strong class="bold-text">{{notification.SenderName}}</strong>&nbsp&nbsp Booking :<strong> {{notification.BookingNumber}} </strong></span>

            <div style="margin-top:0px; margin-bottom:5px;margin-left:5px;;" class="h5">
            {{notification.Title}} <small class="pull-right text-muted" >
                                        <span class="glyphicon glyphicon-time text-muted" ></span> {{sentDate(notification.SentDate)}}</small>
                                        
            </div>        
            
           <button class="btn btn-info btn-block" @click="viewNotification(notification)" >Visit Booking Page</button>
           <hr style="margin-bottom:0px;" v-if="index!=(notificationsComp.length-1)">
        </div>
                
          

      </li>
          <li v-if="notificationsComp.length==0">
           
        <div class="custom-class">
          
          <h5 class="text-muted text-center"><strong > Dupaws notifications</strong></h5>
          <h5 class="text-center">You dont have any notifications yet</h5>
          
        </div>
      </li>
     

    </ul>
  </div>
</template>
<script>
import router from '../../router/index.js'
const API_URL = "https://www.dupaws.com/services/"
import store from '../../data/store.js'
export default {

props:['bindId'], //used this to make fresh component for mobile view and web view notification to remove open class easily via jquery.
data () {
        return {
         active: false
            
      }
},
methods:{
  sentDate: function(date){
        return moment(date).fromNow()
  },
  deleteNotification(notification){
      $.ajax({
            type: 'GET',
            url: API_URL + "api/deleteNotification/" + notification.UserNotificationId,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
                store.commit('deleteNotification',notification)
            },
            error: function(data, status, error) {
                console.log("failed to delete Notification" + data.responseText)
            }
        })   
  },
  readNotification(notification){
       $.ajax({
            type: 'GET',
            url: API_URL + "api/readNotification/" + notification.UserNotificationId,
            beforeSend: function(xhr) {
                xhr.setRequestHeader('Authorization', 'bearer ' + localStorage.getItem('access_token'))
            },
            crossDomain: true,
            contentType: "application/json; charset=utf-8",
            success: function(data) {
              
                store.commit('readNotification',notification)
            },
            error: function(data, status, error) {
                console.log("failed to mark Notification as read" + data.responseText)
            }
        })   
  },
  viewNotification(notification){
    var self = this
    
    if (store.getters.userRole=="Sitter")
    { 
         router.push({name: 'view-sitter-reservation', params: {reservationId: notification.ServiceTransactionId}})
    }
    else if (store.getters.userRole=="Client")
    {
        router.push({name: 'view-reservation', params: {reservationId: notification.ServiceTransactionId}})
    }
    self.readNotification(notification)
    
    
    
    $('#' + this.bindId).removeClass('open')  //used with bindId to close notification (toggle hide) on view reservation.
    
    
  }
    
    
},
mounted: function(){
  var self = this
 
  this.refreshInterval = setInterval(function(){
          self.$forceUpdate()
      }, 15000)
      
},
beforeDestroy: function(){
   var self = this
   clearInterval(this.refreshInterval)
},  
computed:{
    // sortedNotifications: function(){
    //   function compare(a,b){
    //         return new Date(b.date) - new Date(a.date);
    //   }
    //   return this.notificationsComp.sort(compare)
    // },
    notificationsComp: function(){
        if (store.getters.Notifications!=null)
          return store.getters.Notifications.slice().reverse()
          
    },
    unreadNotificationsComp: function(){
        if (store.getters.Notifications!=null)
          return store.getters.Notifications.slice().reverse().filter(function (obj){
            return obj.IsRead==false
        })
    }
}


}

</script>
<style scoped>
.read{
  color:#a4a1a1;
}


.wrap-text{
   width: 200px;
   word-wrap: break-word !important;
}

.scrollable-menu{
    height: auto;
    max-height: 450px;
    overflow-x: hidden;
}

.header-li{
    padding: 10px;
    font-size: smaller;
    padding-left: 0px;
    font-family: inherit;
}



.badge {
  margin-left:5px;
  
}


.badge-error {
  background-color: #b94a48;
}


.glyphicon{
  top:2px;
}


.bold-text{
  font-family: 'Yanone Kaffeesatz', sans-serif;
  font-weight:600;
    font-size: 1.4em;
}


</style>


// WEBPACK FOOTER //
// Notifications.vue?1f0f29be